import { Component, OnInit, Input, ChangeDetectionStrategy, Output, EventEmitter, ViewChild, ElementRef } from '@angular/core';
import { IPodcastViewModel } from '@core/models/interfaces/i-podcast-view-model';
import { IContentCategoryViewModel } from '@core/models/interfaces/i-content-category-view-model';
import { IArticleViewModel } from '@core/models/interfaces/i-articles-view-model';
import { ModalManagementService } from '@app/shared/utils/modal-management.service';
import { GtmService } from '@app/shared/services/lib/gtm.service';
import { LogHomeCatalog } from '@app/core/models/interfaces/promotion-alert-track';
import { IUser } from '@app/core/models/interfaces/i-user.interface';
import { LocalStorage } from 'ngx-webstorage';
import { Router } from '@angular/router';
import { environment as ENV } from '@environment/environment';

@Component({
  selector: 'app-carousel-center',
  templateUrl: './carousel-center.component.html',
  styleUrls: ['./carousel-center.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class CarouselCenterComponent implements OnInit {

  @Input() podcastsList: IPodcastViewModel[];
  @Input() catList: IContentCategoryViewModel[] | any[];
  @Input() article: IArticleViewModel;
  @Input() newHeroArticle: boolean;
  @Input() isLibrary: boolean = false;
  @Input() isPodcast: boolean = false;
  @Input() showFilter: boolean;
  @Input() featured = [];
  @Input() comunityList = [];
  @Input() isComunity: boolean;
  @Output() cpsItem = new EventEmitter<string>();

  @LocalStorage('user') private user: IUser;

  IsArticle: boolean = false;
  options: any = {
    wrapAround: true,
    freeScroll: true,
    pageDots: false,
    draggable: false,
    autoPlay: true,
    groupCells: true,
    resize: true,
    imagesLoaded: true,
    initialIndex: 0,
    cellAlign: 'center'
  };

  constructor(
    private modalManagementService: ModalManagementService,
    private gtmService: GtmService,
    private router: Router
  ) { }

  ngOnInit() {
    if(this.podcastsList && this.podcastsList.length > 0) {
      this.isPodcast = true;
    } else {
      if (!this.isLibrary && !this.newHeroArticle)
        this.IsArticle = true;
    }
  }

  openMoreInfo(contentId: string, contentType: string){
    this.trackCatalog(contentId, contentType);
    this.modalManagementService.openModalMoreInfo(
      contentId, contentType
    );
  }

  trackCatalog(contentId: string, contentType: string): void {
    const homeCatalogTrack: LogHomeCatalog = {
      eventName: 'clickedContentItem',
      event: 'clickedContentItem',
      pageUrl: this.router.url,
      catalogId: '',
      contentId: contentId,
      userId: this.user?.id ?? null,
      contentType: contentType,
      env: ENV.name,
      fromMobile: false
    };
    this.gtmService.logHomeCatalogs(homeCatalogTrack);
  }

  openDetail(item: any): void {
    this.cpsItem.emit(item.id);
  }

}
